let resumeData = {
  "name": "Srini",
  "roleDescription": "A musician and producer from Pune, India. Check out my work here!",
  "mailId": "srinibasmisra.music@gmail.com",
  "codeSite": "https://linktr.ee/srinibass_",
  "socialLinks":[
      {
        "name":"instagram",
        "url":"https://instagram.com/srinibass_",
        "className":"fa fa-instagram"
      },
      {
        "name":"youtube",
        "url":"https://www.youtube.com/channel/UCHZAkw1QxeKHMDKeicXR_AA",
        "className":"fa fa-youtube-play"
      },
      {
        "name": "bandcamp",
        "url": "https://srini.bandcamp.com",
        "className": "fab fa-bandcamp"
      },
      {
        "name": "spotify",
        "url": "https://open.spotify.com/artist/6xTd3GLN7HzhXrnQHxKdE8?si=ptoyP3lsRJqJcEt3G6qD2g",
        "className": "fab fa-spotify"
      },
      {
        "name": "apple",
        "url": "https://music.apple.com/in/artist/srini/1552823850",
        "className": "fa fa-apple"
      },
      {
        "name": "soundcloud",
        "url": "https://soundcloud.com/srinibasmisra",
        "className": "fa fa-soundcloud"
      }
    ],
  "portfolio":[
    {
      "title": "Checkout my latest single!",
      "bgrid": "halves",
      "style": "",
      "items": [
        {
          "name": "Playthrough Video",
          "description": "Playthrough video for Crusade!",
          "imgurl":"images/srini-crusade-streaming.png",
          "url": "https://youtu.be/955ackiYjxo"
        },
        {
          "name": "Streaming Platforms!",
          "description": "Stream the song on your favourite streaming platform!",
          "imgurl":"images/srini-crusade-youtube.png",
          "url": "https://linktr.ee/srini_crusade"
        }
      ]
    },
    {
      "title": "Check out some of my other songs!",
      "bgrid": "quarters",
      "style": "",
      "items": [
        {
          "name":"Unity",
          "description":"",
          "imgurl":"images/unity-square-artwork.png",
          "url": "https://linktr.ee/srini_unity"
        },
        {
          "name":"Ether",
          "description":"",
          "imgurl":"images/ether.png",
          "url": "https://youtu.be/p17A7tvFo_Y"
        },
        {
          "name":"Broken",
          "description":"",
          "imgurl":"images/broken.jpg",
          "url": "https://youtu.be/MrwbzW9TAGw"
        },
        {
          "name":"Sweet Dreams",
          "description":"",
          "imgurl":"images/sweet-dreams.jpg",
          "url": "https://youtu.be/wU9nvFukurI"
        }
      ]
    },
    {
      "title": "Check out some my bands' music!",
      "bgrid": "full",
      "style": "",
      "items": []
    },
    {
      "title": "Sly Verity",
      "bgrid": "full",
      "style": "",
      "items": [
        {
          "name": "Closure Live At Rhapsody Recording",
          "description": "",
          "imgurl": "images/sly-verity-closure.jpeg",
          "url": "https://www.youtube.com/watch?v=8Xd3qpIk9Bc"
        }
      ]
    },
    {
      "title": "Scriptures In The Attic",
      "bgrid": "halves",
      "style": "",
      "items": [
        {
          "name": "The Traveller - Scriptures In The Attic",
          "description": "",
          "imgurl":"images/the-traveller-album-art.png",
          "url": "https://linktr.ee/scripturesintheattic"
        },
        {
          "name": "The Traveller Live Playthrough - Scriptures In The Attic",
          "description": "",
          "imgurl":"images/the-traveller-playthrough-artwork.png",
          "url": "https://youtu.be/p_QGc-cgFAM"
        }
      ]
    },
    {
      "title": "Piyush Bhisekar",
      "bgrid": "halves",
      "style": "",
      "items": [
        {
          "name":"Piyush Bhisekar - Hai Bharosa EP",
          "description":"",
          "imgurl":"images/hai-bharosa.jpg",
          "url": "https://www.youtube.com/watch?v=Prr6c5ybqrs"
        },
        {
          "name":"Piyush Bhisekar - Sabr",
          "description":"",
          "imgurl":"images/sabr.jpg",
          "url": "https://www.youtube.com/watch?v=brPwEwHw-4Q"
        }
      ]
    },
    {
      "title": "Coffee for Giraffes",
      "bgrid": "halves",
      "style": "",
      "items": [
        {
          "name":"Coffee For Giraffes - Summer Live",
          "description":"",
          "imgurl":"images/giraffes-summer-live.png",
          "url": "https://soundcloud.com/vishwa-khare/coffee-for-giraffes-summerlive-at-high-spirits-cafe"
        },
        {
          "name":"Coffee For Giraffes - Dust On The Ground",
          "description":"",
          "imgurl":"images/giraffes-dust-on-the-ground.png",
          "url": "https://www.youtube.com/watch?v=QxRnsR6dbcY"
        }
      ]
    }
  ]
}

export default resumeData



// WEBPACK FOOTER //
// ./src/resumeData.js